import { DefaultTheme } from "styled-components";

const Theme: DefaultTheme = {
  colors: {
    primary: "#E39435",
    primaryDark: "#D17F20", // Darker shade of primary for hover states
    secondary: "#76B041",
    secondaryDark: "#5E8C34", // Darker shade of secondary
    secondaryText: "#5BA43B",
    LoginInputColor: "#34A853",
    background: "#FFF",
    backgroundLightPrimary: "#fffdf2",
    TextWhite: "#FFFFFF",
    text: "#58595B",
    //#1E2F23
    lightGray: "#F5F5F5",
    gray: "#CCCCCC",
    lightGrayTitle: "#9A9A9A",
    darkGray: "#5A5A5A",
    darkGraylight: "#C2B6A6",
    underline: "#E2E2E2",
    error: "#FF6B6B",
    errorDark: "#E25555", // Darker shade of error for hover states
    success: "#4CAF50",
    warning: "#FFC107",
    info: "#2196F3",
    border: "#FFD39D",
    tableHeaderColor: "#B5B7C0",
    placeholder: "#B0B0B0",
    white: "#FFF",
    disabled : "#A5A5A5",
    hoverColor: "#FCEFD9"
  },
  fonts: {
    body: "Roboto, sans-serif",
  },
  fontSizes: {
    xsmall: "10px",
    small: "12px",
    medium: "14px",
    large: "16px",
    xlarge: "20px",
    xxlarge: "22px",
    xxxlarge: "24px",
    xxxxlarge: "30px",
  },

  fontWeights: {
    normal: 400,
    medium: 500,
    bold: 600,
    xbold: 700,
    xxbold: 900,
  },

  spacing: {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem",
    xxl: "3rem",
  },
  borderRadius: {
    small: "4px",
    medium: "6px",
    large: "10px",
    round: "50%",
  },
  breakpoints: {
    mobile: "576px",
    tablet: "768px",
    desktop: "992px",
    largeDesktop: "1200px",
  },
  shadows: {
    small: "0 2px 4px rgba(0, 0, 0, 0.1)",
    medium: "0 4px 8px rgba(0, 0, 0, 0.1)",
    large: "0 8px 16px rgba(0, 0, 0, 0.1)",
  },
};

export default Theme;
